import { TitleText } from '@calendly/ui/components/typography'
import Marked from 'marked-react'
import styled from 'astroturf/react'

import { useI18n } from 'locales'
import { Illustration } from 'components/confirmation/pages/personalized_confirmation/illustration'
import { useStatsigLayer } from 'hooks/use-statsig-layer'

import { Layout } from './layout'
import { Icons } from './icons'
import { SocialProof } from './social_proof'
import _TitleContainer from "index-TitleContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/marketing_banner/index.js?styleId=TitleContainer";
import _SubtitleWrapper from "index-SubtitleWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/marketing_banner/index.js?styleId=SubtitleWrapper";


const TitleContainer = /*#__PURE__*/styled('div', null, {
  displayName: "TitleContainer",
  styles: _TitleContainer
})

const SubtitleWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "SubtitleWrapper",
  styles: _SubtitleWrapper
})

const Hero = () => {
  const layer = useStatsigLayer('booking_flow')
  const variant = layer.get('confirmation_illustration_variant')
  const twoColumnDesign = layer.get('confirmation_page_two_column_design')

  if (variant === 'link') return <Illustration />
  if (variant === 'link_animated') return <Illustration animate />
  if (variant === 'icons') return <Icons />
  if (variant === 'social_proof') return <SocialProof />
  if (twoColumnDesign) return <Illustration />
  return null
}

const getTitleAndSubtitle = (illustrationVariant) => {
  switch (illustrationVariant) {
    case 'link_animated':
      return {
        titleKey: 'booking.templates.signup_form.marketing_experiment_link_animated.hero_title',
        subtitleKey: 'booking.templates.signup_form.marketing_experiment_link_animated.hero_subtitle'
      }
    case 'icons':
      return {
        titleKey: 'booking.templates.signup_form.marketing_experiment_icons.hero_title',
        subtitleKey: 'booking.templates.signup_form.marketing_experiment_icons.hero_subtitle'
      }
    case 'social_proof':
      return {
        titleKey: 'booking.templates.signup_form.marketing_experiment_social_proof.hero_title',
        subtitleKey: 'booking.templates.signup_form.marketing_experiment_social_proof.hero_subtitle'
      }
    case 'link':
    default:
      // control
      return {
        titleKey: 'booking.templates.signup_form.marketing_experiment_link.hero_title',
        subtitleKey: 'booking.templates.signup_form.marketing_experiment_link.hero_subtitle'
      }
  }
}


export const MarketingBanner = () => {
  const { i18n } = useI18n()
  const layer = useStatsigLayer('booking_flow')
  const variant = layer.get('confirmation_illustration_variant')

  const { titleKey, subtitleKey } = getTitleAndSubtitle(variant)

  const title = i18n.t(titleKey)
  const subtitle = i18n.t(subtitleKey)

  return (
    <Layout variant={variant}>
      {(!!title || !!subtitle) && (
      <TitleContainer>
        <TitleText level={3}><Marked>{title}</Marked></TitleText>
        <SubtitleWrapper>
          <TitleText level={4} variant="normal"><Marked>{subtitle}</Marked></TitleText>
        </SubtitleWrapper>
      </TitleContainer>
      )}
      <Hero />
    </Layout>
  )
}
